let scrollY = 0;

function throttle(callee, timeout) {
    // Таймер будет определять,
    // надо ли нам пропускать текущий вызов.
    let timer = null

    // Как результат возвращаем другую функцию.
    // Это нужно, чтобы мы могли не менять другие части кода,
    // чуть позже мы увидим, как это помогает.
    return function perform(...args) {
        // Если таймер есть, то функция уже была вызвана,
        // и значит новый вызов следует пропустить.
        if (timer) return

        // Если таймера нет, значит мы можем вызвать функцию:
        timer = setTimeout(() => {
            // Аргументы передаём неизменными в функцию-аргумент:
            callee(...args)

            // По окончании очищаем таймер:
            clearTimeout(timer)
            timer = null
        }, timeout)
    }
}

function disableAppScroll() {
    setTimeout(() => {
        scrollY = window.scrollY
        const app = document.getElementById('app')
        if (app) {
            app.style.overflow = 'hidden'
        }
    }, 500)
}

function enableAppScroll() {
    const app = document.getElementById('app')
    if (app) {
        app.style.overflow = ''
    }
    window.scrollTo({ top: scrollY })
}

module.exports = {
    throttle, disableAppScroll, enableAppScroll
}
